import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as types from '../../../constants/actionTypes';
import { actions as locationActions } from '../../../actions/locationActions';
import PropTypes from 'prop-types';
import Drawer from '../../Common/Drawer/Drawer';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';

export class BulkUpdateAttributesDrawer extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			showConfirmDeleteModal: false,
			isFormValid: true,
			isLoading: false,
			areas: [],
			continents: [],
			locationTypes: [],
			managementCompanies: [],
			regions: [],
			areaId: 0,
			continentId: 0,
			locationTypeId: 0,
			managementCompanyId: 0,
			regionId: 0,
		};
	}

	componentDidMount = async () => {
		if (this.props.selectedLocationIds.length < 1) {
			Notification('error', 'Error', 'At least one location must be selected');
			this.onCancel();
		}

		await this.loadFilters();
	};

	loadFilters = async () => {
		try {
			this.setState({ isLoading: true });
			const response = await this.props.locationActions.loadFormFilters(this.props.subscriptionId);
			if (response.type === types.LOAD_LOCATION_FORM_FILTERS_SUCCESS) {
				//we want the user to have the option to select "No Change" so we will append it to the array here
				this.setState({
					areas: [{ id: 0, name: 'No Change' }, ...response.payload.areas],
					continents: [{ id: 0, name: 'No Change' }, ...response.payload.continents],
					locationTypes: [{ id: 0, name: 'No Change' }, ...response.payload.locationTypes],
					managementCompanies: [{ id: 0, name: 'No Change' }, ...response.payload.managementCompanies],
					regions: [{ id: 0, name: 'No Change' }, ...response.payload.regions],
				});
			} else if (response.type === types.LOAD_LOCATION_FORM_FILTERS_FAILURE) {
				Notification('error', 'An Error Occurred', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	onSave = async () => {
		try {
			this.setState({ isLoading: true });

			const { areaId, continentId, locationTypeId, managementCompanyId, regionId } = this.state;

			const request = {
				subscriptionId: this.props.subscriptionId,
				locationIds: this.props.selectedLocationIds,
				areaId,
				continentId,
				locationTypeId,
				managementCompanyId,
				regionId,
			};

			const response = await this.props.locationActions.bulkUpdateAttributes(request);
			if (response.type === types.BULK_LOCATION_ATTRIBUTES_SUCCESS) {
				Notification('success', 'Success', 'Location attributes updated successfully');
				this.props.onComplete();
			} else if (response.type === types.BULK_LOCATION_ATTRIBUTES_FAILURE) {
				Notification('error', 'Error', response.payload.message);
				this.setState({ isLoading: false });
			}
		} catch (error) {
			Notification('error', 'Error', error);
			this.setState({ isLoading: false });
		}
	};

	onMultiSelectChange = (value, name) => {
		this.setState({ [name]: value });
	};

	render() {
		return (
			<Drawer isWide={false} title='Update Attributes' onSaveClick={this.onSave} saveText={'Update'} onCancelClick={this.props.onCancel}>
				<LoadingIndicator isLoading={this.state.isLoading}>
					<form className='update-attr-drawer' noValidate>
						<div className='row'>
							<div className='col'>
								<MultiSelectBox
									name='areaId'
									label='Areas'
									idField='id'
									valueField='name'
									options={this.state.areas}
									selectedValues={this.state.areaId.toString()}
									onChange={this.onMultiSelectChange}
									isRequired={false}
									isMulti={false}
								/>

								<MultiSelectBox
									name='continentId'
									label='Continents'
									idField='id'
									valueField='name'
									options={this.state.continents}
									selectedValues={this.state.continentId.toString()}
									onChange={this.onMultiSelectChange}
									isRequired={false}
									isMulti={false}
								/>

								<MultiSelectBox
									name='locationTypeId'
									label='Types'
									idField='id'
									valueField='name'
									options={this.state.locationTypes}
									selectedValues={this.state.locationTypeId.toString()}
									onChange={this.onMultiSelectChange}
									isRequired={false}
									isMulti={false}
								/>

								<MultiSelectBox
									name='managementCompanyId'
									label='Management Companies'
									idField='id'
									valueField='name'
									options={this.state.managementCompanies}
									selectedValues={this.state.managementCompanyId.toString()}
									onChange={this.onMultiSelectChange}
									isRequired={false}
									isMulti={false}
								/>

								<MultiSelectBox
									name='regionId'
									label='Regions'
									idField='id'
									valueField='name'
									options={this.state.regions}
									selectedValues={this.state.regionId.toString()}
									onChange={this.onMultiSelectChange}
									isRequired={false}
									isMulti={false}
								/>
							</div>
						</div>
					</form>
				</LoadingIndicator>
			</Drawer>
		);
	}
}

BulkUpdateAttributesDrawer.propTypes = {
	locationActions: PropTypes.object.isRequired,
	onComplete: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	selectedLocationIds: PropTypes.array.isRequired,
	subscriptionId: PropTypes.string.isRequired,
};

function mapDispatchToProps(dispatch) {
	return {
		locationActions: bindActionCreators(locationActions, dispatch),
	};
}

export default connect(null, mapDispatchToProps)(BulkUpdateAttributesDrawer);
